import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../../../utils/propUtils';
var VeltActivityLogHeaderFilterContentItemLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-header-filter-content-item-label-wireframe", __assign({}, transformedProps), children));
};
export default VeltActivityLogHeaderFilterContentItemLabelWireframe;
